import type { ProviderTypeFilter } from "../search/discovery-search.contract.ts";
import type { FindFeedRowKey } from "./find-feed.contract.ts";

export type FindFeedRowFilters = {
    friendlinessChildren?: {
        value: "1" | "2" | "3" | "4" | "5";
        operator: "eq" | "gte" | "lte";
    }[];
    friendlinessDogs?: {
        value: "1" | "2" | "3" | "4" | "5";
        operator: "eq" | "gte" | "lte";
    }[];
    friendlinessCats?: {
        value: "1" | "2" | "3" | "4" | "5";
        operator: "eq" | "gte" | "lte";
    }[];
    trainability?: {
        value: "1" | "2" | "3" | "4" | "5";
        operator: "eq" | "gte" | "lte";
    }[];
    energyLevel?: {
        value: "1" | "2" | "3" | "4" | "5";
        operator: "eq" | "gte" | "lte";
    }[];
    healthIssuesRisk?: {
        value: "1" | "2" | "3" | "4" | "5";
        operator: "eq" | "gte" | "lte";
    }[];
    hypoallergenic?: boolean;
    providerType?: ProviderTypeFilter;
};

export type FindFeedRowDefinition = {
    key: FindFeedRowKey;
    title: string;
    filters: FindFeedRowFilters;
};

const createGteRatingFilter = (value: "1" | "2" | "3" | "4" | "5") => ({
    value,
    operator: "gte" as const,
});

const createLteRatingFilter = (value: "1" | "2" | "3" | "4" | "5") => ({
    value,
    operator: "lte" as const,
});

export const findFeedRowDefinitions: FindFeedRowDefinition[] = [
    {
        key: "great-for-families",
        title: "Great for families",
        filters: {
            friendlinessChildren: [createGteRatingFilter("4")],
            friendlinessDogs: [createGteRatingFilter("3")],
        },
    },
    {
        key: "from-breeders",
        title: "From breeders near you",
        filters: {
            providerType: "breeder",
        },
    },
    {
        key: "from-shelters",
        title: "From shelters near you",
        filters: {
            providerType: "shelter_rescue",
        },
    },
    {
        key: "hypoallergenic",
        title: "Hypoallergenic breeds",
        filters: {
            hypoallergenic: true,
        },
    },
    {
        key: "first-time-owners",
        title: "Great for first-time owners",
        filters: {
            trainability: [createGteRatingFilter("4")],
            energyLevel: [createLteRatingFilter("3")],
        },
    },
    {
        key: "good-with-cats",
        title: "Good with cats",
        filters: {
            friendlinessCats: [createGteRatingFilter("4")],
        },
    },
    {
        key: "active-adventurous",
        title: "Active & adventurous",
        filters: {
            energyLevel: [createGteRatingFilter("4")],
        },
    },
    {
        key: "calm-easygoing",
        title: "Calm & easygoing",
        filters: {
            energyLevel: [createLteRatingFilter("2")],
        },
    },
    {
        key: "healthy-breeds",
        title: "Healthy breeds",
        filters: {
            healthIssuesRisk: [createLteRatingFilter("2")],
        },
    },
];
